import { useState } from "react";
import { Ellipsis, Eye, Trash } from "lucide-react";
import useClickOutside from "../../../../../CustomHooks/useClickOutside";
import UsePermissionsClaim from "../../../../../CustomHooks/UsePermissionsClaim";
import MaterialTransportDialog from "../../../dialog/MaterialTransportDialog";
import MaterialDelete from "./MaterialDelete";

function MaterialActions({ material }) {
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmDelete, setConfirmDelere] = useState(false);
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));
  const { checkPermission } = UsePermissionsClaim();
  const deleteMaterial = checkPermission("delete_material_transport");

  const handleShow = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };

  return (
    <div className="table-action-btn" onClick={handleShow} ref={dropdownRef}>
      <Ellipsis />
      {open === 1 && (
        <div
          className={`actionsWrap--u ${open === 1 ? "grid" : "invisible"} font-figtree`}
        >
          <button
            className="py-1 px-2 border-b-1 border-lg5 flex items-center hover:bg-blue-100"
            onClick={() => setOpenDialog(true)}
          >
            <Eye size={20} />
            <span className="pl-2">View Details</span>
          </button>

          {deleteMaterial && (
            <button
              className="py-1 px-2 flex items-center hover:bg-blue-100 text-red-600"
              onClick={() => setConfirmDelere(true)}
            >
              <Trash size={18} />
              <span className="pl-2">Delete</span>
            </button>
          )}
        </div>
      )}
      {openDialog && (
        <MaterialTransportDialog
          details={material}
          closeDialog={() => setOpenDialog(false)}
        />
      )}
      {confirmDelete && (
        <MaterialDelete
          material={material}
          setConfirmDelere={setConfirmDelere}
        />
      )}
    </div>
  );
}
export default MaterialActions;
